import { render, staticRenderFns } from "./onboardingDocumentsComponent.vue?vue&type=template&id=7d67451f&"
import script from "./onboardingDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./onboardingDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports